export default {
    pl: {
        currency: {
            style: 'currency',
            currency: 'PLN'
        }
    }
}
